import React from 'react';
import { Star, Shield, Users, Award, Truck, CheckCircle2 } from 'lucide-react';
const HIGHLIGHTS = [{
  title: 'Model identification help',
  desc: 'We help you find the exact manufacturer and model of your current mailbox to ensure a perfect replacement match.'
}, {
  title: 'Commercial project guidance',
  desc: 'Expert review of your door counts, numbering sequences, and USPS requirements before you place a commercial order.'
}];
const BADGES = [{
  icon: Users,
  label: 'Family-owned'
}, {
  icon: Award,
  label: 'Woman-owned'
}, {
  icon: Shield,
  label: '22+ years'
}, {
  icon: Star,
  label: 'Top-rated manufacturers'
}, {
  icon: Truck,
  label: 'Nationwide shipping'
}];
export function ReviewsTrust() {
  return <section className="py-16 bg-white border-t border-brand-border" data-id="element-329">
      <div className="max-w-7xl mx-auto px-4" data-id="element-330">
        {/* Confidence Highlights */}
        <div className="text-center mb-10" data-id="element-331">
          <h2 className="text-2xl lg:text-3xl font-serif font-bold text-brand-charcoal" data-id="element-332">
            Customer confidence highlights
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16 max-w-5xl mx-auto" data-id="element-333">
          {HIGHLIGHTS.map((highlight, idx) => <div key={idx} className="bg-brand-cream p-8 rounded-xl border border-brand-border flex items-start gap-4" data-id="element-334">
              <CheckCircle2 className="text-brand-green shrink-0 mt-1" size={24} data-id="element-335" />
              <div data-id="element-336">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2" data-id="element-337">
                  {highlight.title}
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-338">
                  {highlight.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Trust Badges */}
        <div className="border-t border-brand-border pt-12" data-id="element-339">
          <div className="flex flex-wrap justify-center gap-8 lg:gap-16" data-id="element-340">
            {BADGES.map((badge, idx) => {
            const Icon = badge.icon;
            return <div key={idx} className="flex flex-col items-center text-center gap-3" data-id="element-341">
                  <div className="w-12 h-12 rounded-full bg-brand-green/5 flex items-center justify-center text-brand-green" data-id="element-342">
                    <Icon size={24} strokeWidth={1.5} data-id="element-343" />
                  </div>
                  <span className="text-sm font-semibold text-brand-charcoal" data-id="element-344">
                    {badge.label}
                  </span>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}